import { render, staticRenderFns } from "./CampaignForm.vue?vue&type=template&id=46d81522&"
import script from "./CampaignForm.vue?vue&type=script&lang=ts&"
export * from "./CampaignForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports